"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFileCategory = getFileCategory;
function getFileCategory(mimetype) {
    var fileType = mimetype ? mimetype : "application/octet-stream";

    if (fileType.indexOf("video/") === 0 || fileType.indexOf("audio/") === 0) {
        return "media";
    }

    if (fileType.indexOf("image/") === 0) {
        return "image";
    }

    if (["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].includes(fileType)) {
        return "spreadsheet";
    }

    if (["application/zip", "application/x-zip-compressed", "application/tar", "application/x-7z-compressed", "application/x-rar-compressed", "application/x-gtar"].includes(fileType)) {
        return "archive";
    }

    if (["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(fileType)) {
        return "document";
    }

    if (["application/pdf"].includes(fileType)) {
        return "pdf";
    }

    return "unknown";
}
//# sourceMappingURL=GetFileCategory.js.map